<div class="custom-select-container">
    <button class="select-trigger" (click)="toggleDropdown()" [attr.aria-expanded]="isOpen" [disabled]="samlService.loadingNewOwner()">
        @if (!samlService.loadingNewOwner()) {
            <span class="selected-label">{{ selectedOption?.name }}</span>
            <img src="assets/icons/arrow-down-blue.svg" alt="chevron" class="chevron" [class.rotated]="isOpen" />
        } @else {
            <app-loading-indicator size="tiny" color="secondary" />
        }
    </button>

    @if (isOpen) {
        <div class="options-panel">
            <ul>
                @for (option of samlService.samlMembershipOwners(); track option.uid) {
                    <li class="option" (click)="selectOption(option)" [class.selected]="option.uid === samlService.chosenUid()">
                        <p>{{ option.name }}</p>

                        @if (option.uid === samlService.chosenUid()) {
                            <img class="checkmark" src="assets/icons/check-circle.svg" alt="check mark" />
                        }
                    </li>
                }
            </ul>
        </div>
    }
</div>
